import { render, staticRenderFns } from "./SerpPrepaymentsFilter.vue?vue&type=template&id=59983ab2&scoped=true"
import script from "./SerpPrepaymentsFilter.vue?vue&type=script&lang=ts"
export * from "./SerpPrepaymentsFilter.vue?vue&type=script&lang=ts"
import style0 from "./SerpPrepaymentsFilter.vue?vue&type=style&index=0&id=59983ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59983ab2",
  null
  
)

export default component.exports